import { Card, Grid, styled } from "@mui/material";

export const SkillsPage = styled("div")(({theme}) => ({
  width: "100vw",
  height: "calc(100vh + 150px )",
  // backgroundColor: "#3957D2",
  // backgroundColor: "red",
  maxHeight: "calc(100vh + 150px)",
  maxWidth: "100vw",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    height: "fit-content",
    maxHeight: "fit-content",
  },
}));

export const SkillsScreen = styled("div")(({theme,dark}) => ({
  width: "100vw",
  height: "calc(100vh - 50px)",
  padding: "20px 40px",
  display: "flex",
  flexDirection: "column",

  "& .page-title": {
    fontSize: "3em",
    color: dark?"#1C2028":"#fff",
    fontWeight: 700,
    margin: "20px 0 0 0 ",
  },
  [theme.breakpoints.down('md')]:{
    padding: '20px 20px',
    height: "fit-content",
    maxHeight: "fit-content",
    "& .page-title": {
      fontSize: "2em",
    },
   }
}));

export const SkillsMainContainer = styled("div")(() => ({
  width: "100%",
  flex: 1,
  display: "flex",
  flexDirection: "row",
}));

export const SkillsLottieContainer = styled("div")(({ theme }) => ({
  width: "30%",
  height: "100%",
  display: "grid",
  placeItems: "center",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const SkillLottie = styled("div")(({theme})=>({
  width:600,
  height:600,
  [theme.breakpoints.down('lg')]:{
    width:400,
    height:400
  }
}))

export const SkillsDataContainer = styled("div")(({ theme }) => ({
  width: "70%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "100%",
    marginTop:'30px'
  },
  // alignItems:'center',
}));

export const SkillGrid = styled(Grid)(({ theme }) => ({
  width: "80%",
  margin: "0 auto",
  // backgroundColor:'red'
  [theme.breakpoints.down("md")]: {
    width: "100%",
    justifyContent:'space-between'
  },

}));
